export const getAppBasename = () => {
  const publicUrl = process.env.PUBLIC_URL || '';
  if (!publicUrl || publicUrl === '/') return '';
  return publicUrl.replace(/\/$/, '');
};

export const withAppBasename = (url = '') => {
  if (
    !url ||
    url.startsWith('http://') ||
    url.startsWith('https://') ||
    url.startsWith('//')
  ) {
    return url;
  }

  const basename = getAppBasename();
  if (!basename) return url;
  if (url === basename || url.startsWith(`${basename}/`)) return url;

  return `${basename}${url.startsWith('/') ? url : `/${url}`}`;
};
